import { isEventKind } from '@/features/publicsite/events/eventKind';
import {
  cleanFilters,
  ISO_DAY,
  orderPeriod,
  RECORD_ID,
  withFilters,
} from '@/features/common/listingFilters';
import type { EventFilterName } from '@/features/publicsite/types/events/EventFilterName';
import type { EventFilters } from '@/features/publicsite/types/events/EventFilters';

const FILTER_NAMES: EventFilterName[] = ['q', 'region', 'theme', 'kind', 'organizer', 'from', 'to'];

function acceptable(name: EventFilterName, value: string): boolean {
  if (name === 'kind') return isEventKind(value);
  if (name === 'from' || name === 'to') return ISO_DAY.test(value);
  if (name === 'region' || name === 'theme' || name === 'organizer') return RECORD_ID.test(value);
  return true;
}

/**
 * The calendar filters the URL holds, cleaned the way /stiri cleans its own: a kind only when it is
 * one of the six, a raion, theme or organiser only when it is an id, period ends only when they are
 * ISO days, and a backwards period turned round. The request, the reset button and the count all
 * read the URL through this.
 */
export function eventFilters(params: URLSearchParams): EventFilters {
  return orderPeriod(cleanFilters(params, FILTER_NAMES, acceptable));
}

/** The calendar's URL after a change to some of its filters. */
export function withEventFilters(
  params: URLSearchParams,
  changes: Partial<Record<EventFilterName, string | null>>,
): URLSearchParams {
  return withFilters(params, changes, eventFilters);
}

/** How many filters are narrowing the calendar — what decides "Resetează" and the count. */
export function activeEventFilterCount(params: URLSearchParams): number {
  return Object.keys(eventFilters(params)).length;
}
